<template>
  <div>
    <div class="profile direct-debit-limit-edit">
      <div class="profile__left">
        <div class="profile__title">Direct Debit Rule</div>
        <div class="profile__caption">Edit Direct Debit Rule</div>
      </div>
      <div class="profile__right">
        <form>
          <div class="form__item no-border">
            <Dropdown
              title="Transaction Limit"
              :label="selected.config_type"
              :options="configType"
              :onOptionSelected="({ id }) => (selected.config_type = id)"
            />
          </div>
          <div class="form__item no-border no-margin-bottom">
            <Input
              label="value"
              :onChange="(value) => (selected.value = value)"
              :value="selected.value"
            />
          </div>
          <div class="form__item no-border">
            <Dropdown
              title="Resource"
              :label="selected.category_id"
              :options="categories"
              :onOptionSelected="({ id }) => (selected.category_id = id)"
            />
          </div>
          <div class="form__item no-border">
            <Dropdown
              title="Period"
              :label="selected.frequency"
              :options="frequency"
              :onOptionSelected="({ id }) => (selected.frequency = id)"
            />
          </div>
        </form>
      </div>
    </div>
    <div class="action">
      <button
        :disabled="disabled"
        @click="updateDirectDebitLimit"
        class="btn btn--primary"
      >
        Save Changes
      </button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Dropdown from "@/components/dropdown";
import Input from "@/components/input";
export default {
  metaInfo: {
    title: "Edit Routing Rule",
  },
  components: {
    Dropdown,
    Input,
  },
  data() {
    return {
      configType: [
        { value: "Transaction Volume", id: "transaction_volume" },
        { value: "Transaction Value", id: "transaction_value" },
        { value: "Transaction Attempt", id: "transaction_attempts" },
      ],
      categories: [
        { value: "Per Merchant", id: 1 },
        { value: "Per Customer", id: 2 },
        { value: "Per Transaction", id: 3 },
      ],
      frequency: [
        { value: "Daily", id: "DAILY" },
        { value: "Weekly", id: "WEEKLY" },
        { value: "Monthly", id: "MONTHLY" },
      ],
      selected: {
        config_type: "",
        value: "",
        frequency: "",
        category_id: "",
      },
      disabled: false,
    };
  },
  created() {
    this.getRoutingRule();
  },
  methods: {
    async getRoutingRule() {
      try {
        const limitType = {
          transaction_volume: "Transaction Volume",
          transaction_value: "Transaction Value",
          transaction_attempts: "Transaction Attempt",
        };
        const volumeType = {
          transaction_volume: "Volume",
          transaction_value: "Value",
          transaction_attempts: "Attempt",
        };

        let url = `${process.env.VUE_APP_DD_API_URL}/admin/mandates/config/limit?configID=${this.$route.params.itemId}`

        if(this.$route.params.id) {
          url = `${process.env.VUE_APP_DD_API_URL}/admin/mandates/merchant/config/${this.$route.params.id}`
        }
        const response = await Vue.http.get(
          url
        );

        this.selected = {
          config_type: response.body.body[0].config_type,
          value: response.body.body[0].value,
          frequency: response.body.body[0].frequency,
          category_id: response.body.body[0].category_id,
        };
      } catch (err) {
        Vue.notify({
          group: "notifications-default",
          type: "error text-white",
          title: "Error",
          text: err.body.message,
        });
      }
    },
    async updateDirectDebitLimit() {
      try {
        this.disabled = true;

         let url = `${process.env.VUE_APP_DD_API_URL}/admin/mandates/config/limit/${this.$route.params.itemId}`

        if(this.$route.params.id) {
          url = `${process.env.VUE_APP_DD_API_URL}/admin/mandates/merchant/config/${this.$route.params.id}/${this.$route.params.itemId}`
        }

        const response = await Vue.http.put(
          url,
          this.selected
        );
        this.disabled = false;
        Vue.notify({
          group: "notifications-default",
          type: "success text-white",
          title: "Direct debit limit",
          text: response.body.message,
        });
      } catch (err) {
        this.disabled = false;
        Vue.notify({
          group: "notifications-default",
          type: "error text-white",
          title: "Error",
          text: err.body.message,
        });
      }
    },
  },
};
</script>
<style lang="scss">
.direct-debit-limit-edit {
  .drop-down {
    width: 100%;
  }
  .custom-input {
    input {
      border: none !important;
      width: 100% !important;
      max-width: 100%;
    }
  }
  .dropdown-options {
    width: 100%;
  }
  .no-border {
    border: none !important;
  }
  .no-margin-bottom {
    margin-bottom: 0 !important;
  }
  .form__item {
    width: 400px !important;
  }
  form {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
}
</style>